/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Endpoint_Returned_More_OneInputs */

const en_endpoint_returned_more_one = /** @type {(inputs: Endpoint_Returned_More_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... ${i?.count} more field`)
};

const zh_hans1_endpoint_returned_more_one = /** @type {(inputs: Endpoint_Returned_More_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... 还有 ${i?.count} 个字段`)
};

const pt_br2_endpoint_returned_more_one = /** @type {(inputs: Endpoint_Returned_More_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... ${i?.count} campo a mais`)
};

const es_endpoint_returned_more_one = /** @type {(inputs: Endpoint_Returned_More_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... ${i?.count} campo más`)
};

const fr_endpoint_returned_more_one = /** @type {(inputs: Endpoint_Returned_More_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... ${i?.count} champ de plus`)
};

const de_endpoint_returned_more_one = /** @type {(inputs: Endpoint_Returned_More_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... ${i?.count} weiteres Feld`)
};

const ru_endpoint_returned_more_one = /** @type {(inputs: Endpoint_Returned_More_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... ещё ${i?.count} поле`)
};

const it_endpoint_returned_more_one = /** @type {(inputs: Endpoint_Returned_More_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... ${i?.count} campo in più`)
};

/**
* | output |
* | --- |
* | "... {count} more field" |
*
* @param {Endpoint_Returned_More_OneInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_returned_more_one = /** @type {((inputs: Endpoint_Returned_More_OneInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Returned_More_OneInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_returned_more_one(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_returned_more_one(inputs)
	if (locale === "es") return es_endpoint_returned_more_one(inputs)
	if (locale === "fr") return fr_endpoint_returned_more_one(inputs)
	if (locale === "de") return de_endpoint_returned_more_one(inputs)
	if (locale === "ru") return ru_endpoint_returned_more_one(inputs)
	if (locale === "it") return it_endpoint_returned_more_one(inputs)
	return en_endpoint_returned_more_one(inputs)
});